import { jsx as _jsx } from "react/jsx-runtime";
import { Resizable as ReResizable } from "re-resizable";
import './style.less';
export const BASE_RANGE = {
    MIN: 288,
    MAX: 488
};
export const Resizable = ({ children, range = BASE_RANGE, ...props }) => {
    return (_jsx(ReResizable, { defaultSize: {
            width: range.MIN,
            height: 'auto',
            ...(props.defaultSize || {})
        }, minWidth: range.MIN, maxWidth: range.MAX, enable: { right: true }, handleClasses: { right: 'ew-resizer-right' }, ...props, children: children }));
};
